<div class="est-rollover-container">
  @if (showRolloverConfirmModal) {
<gtw-confirmation-modal
   
    [config]="rolloverConfirmConfig"
    [visible]="showRolloverConfirmModal"
    (confirmed)="onConfirmRollover()"
    (cancelled)="onCancelRollover()"
    (closed)="onCancelRollover()">
  </gtw-confirmation-modal>
}

  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (showBackdrop && !showFormLoader) {
<div class="text-center" style="padding: 20px;">
    <p>Please select filters and click <strong>Filter</strong> to load EST rollover data.</p>
  </div>
}

  @if (!showFormLoader && !showBackdrop) {
<div class="est-rollover-panel">
    <div class="est-rollover-toolbar">
      <button class="add-row-btn" (click)="addRollover()">
        <i class="fa fa-plus-circle"></i> Add row to Rollover
      </button>
    </div>

    @for (rolloverItem of rollovers; track $index; let i = $index) {
<div class="est-rollover-row">
      <button class="delete-row-btn"
              [disabled]="rolloverItem.rollover_status === 1"
              (click)="deleteRollover(i)"
              title="Delete row">
        <i class="fa fa-minus-circle"></i>
      </button>

      <div class="field-group">
        <label>Tax Year:</label>
        <input class="form-control input-sm" [value]="rolloverItem.tax_year" disabled>
      </div>

      <div class="field-group">
        <label>Out Tax Year:</label>
        <input class="form-control input-sm" [value]="rolloverItem.out_tax_year" disabled>
      </div>

      <div class="field-group">
        <label>From Quarter:</label>
        <select class="form-control input-sm"
                  [compareWith]="compareQuarterByValue"
                  [ngModel]="rolloverItem.from_qtr"
                  (ngModelChange)="rolloverItem.from_qtr = $event; onFromQuarterChange(rolloverItem, i)"
                  [disabled]="rolloverItem.rollover_status === 1">
          <option [ngValue]="null">Select</option>
          @for (q of fromQuarterList; track $index) {
<option [ngValue]="q">{{ q.LABEL }}</option>
}
        </select>
      </div>

      <div class="field-group">
        <label>To Quarter:</label>
        <select class="form-control input-sm"
                  [compareWith]="compareQuarterByValue"
                  [ngModel]="rolloverItem.to_qtr"
                  (ngModelChange)="rolloverItem.to_qtr = $event"
                  [disabled]="rolloverItem.rollover_status === 1">
          <option [ngValue]="null">Select</option>
          @for (q of toQuarterList[i]; track $index) {
<option [ngValue]="q">{{ q.LABEL }}</option>
}
        </select>
      </div>

      <div class="field-group checkbox-group">
        <label>Rollover:</label>
        <input type="checkbox"
               [checked]="rolloverItem.rollover_status === 1"
               (change)="onRolloverToggle($event, rolloverItem, i)"
               [disabled]="rolloverItem.rollover_status === 1">
      </div>
    </div>
}

    @if (rollovers.length === 0) {
<div class="text-center" style="padding: 20px;">
      <p>No rollover data available.</p>
    </div>
}
  </div>
}
</div>
